module.exports = __webpack_public_path__ + "static/media/01.b9ebdbf1.png";